import { PATHWAY_META, TONES, money } from "@/lib/pathways";
import { ArrowUpRight, Bookmark } from "lucide-react";
import { track } from "@/lib/api";

export function PathwayCard({ pathway, index, onSave }) {
  const meta = PATHWAY_META[pathway.type] || { tag: pathway.type, tone: "cream" };
  const color = TONES[meta.tone] || TONES.cream;

  return (
    <div
      data-testid={`pathway-card-${meta.tag.toLowerCase().replace(/\s+/g, "-")}`}
      className="border hairline bg-[#141417] p-6 md:p-8 flex flex-col fade-up"
      style={{ animationDelay: `${(index || 0) * 60}ms` }}
    >
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex items-center gap-3">
          <span className="font-label text-[10px] text-stone-600">{String((index || 0) + 1).padStart(2, "0")}</span>
          <span className="font-label text-xs tracking-widest px-2 py-1 border" style={{ color, borderColor: color }}>
            {meta.tag}
          </span>
        </div>
        {pathway.potential_savings > 0 && (
          <div className="text-right">
            <div className="font-label text-[9px] tracking-widest text-stone-500">SAVE</div>
            <div className="font-display text-2xl leading-none" style={{ color: TONES.green }}>
              {money(pathway.potential_savings)}
            </div>
          </div>
        )}
      </div>

      <h3 className="font-display text-2xl font-semibold leading-tight mb-2">{pathway.title}</h3>
      <p className="text-sm text-stone-400 leading-relaxed mb-5">{pathway.description}</p>

      <div className="mt-auto space-y-2">
        {(pathway.options || []).map((o, i) => (
          <a
            key={i}
            href={o.url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("affiliate_clicked", { name: o.name, pathway: pathway.type })}
            data-testid={`pathway-option-${i}`}
            className="group flex items-center justify-between border-t hairline pt-2 first:border-t-0 first:pt-0"
          >
            <div>
              <div className="font-label text-xs text-stone-200 group-hover:text-[#E63946] transition-colors">{o.name}</div>
              {o.note && <div className="text-xs text-stone-300 leading-snug">{o.note}</div>}
            </div>
            <ArrowUpRight className="w-4 h-4 text-stone-600 group-hover:text-[#E63946] transition-colors shrink-0" />
          </a>
        ))}
      </div>

      {onSave && (
        <button
          onClick={() => onSave(pathway)}
          data-testid="save-pathway-btn"
          className="mt-5 flex items-center gap-2 font-label text-[10px] tracking-widest text-stone-400 hover:text-[#E63946] transition-colors self-start"
        >
          <Bookmark className="w-3 h-3" /> SAVE THIS
        </button>
      )}
    </div>
  );
}
